<template>
  <v-col v-if="isLockable" class="justify-space-between wrap d-inline-flex align-center pt-0" cols="12">
    <v-switch v-model="registrar_lock" @change="switchModalState">
      <template v-slot:label>
        <div>
          Registrar Lock
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon class="mb-1"  @click.stop v-on="on">mdi-information-outline</v-icon>
            </template>
            Locking your domain prevents it from being transferred away
          </v-tooltip>
        </div>
      </template>
    </v-switch>

    <gg-btn
      v-if="allowEPP"
      primary
      tile

      color="primary"
      :loading="loading_epp"
      @click="sendEPP">
      Send EPP / Transfer Code
    </gg-btn>

    <gg-modal :is-active="modal" @close="switchModalState('cancel')">
      <template v-slot:toolbar>
        Registrar Lock
      </template>
      <template v-slot:body>
        <div class="" v-if="registrar_lock">
          Locking your domain name will prevent your domain from being transferred to another provider and protect
          against accidental transfer.<br><br>Are you sure you wish to continue?
        </div>
        <div v-else>
          Unlocking your domain name will make it available to transfer to another provider. Leaving your domain name
          unlocked could lead to accidental transfer.<br><br>Are you sure you wish to continue?
        </div>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="switchModalState('cancel')">Cancel</gg-btn>
        <gg-btn primary :loading="loading" @click="setRegLock">Save</gg-btn>
      </template>
    </gg-modal>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RegistarLock',
  props: {
    domainid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    registrar_lock: false,
    modal: false,
    loading: false,
    loading_epp: false,
  }),
  computed: {
    ...mapGetters(['domain', 'domainPopulated']),
    isLockable () {
      if (this.domain.IsLockable) {
        return true
      } else {
        return false
      }
    },
    allowEPP () {
      console.log(this.domain)
      if (this.domain.allowEPP) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    domainPopulated () {
      this.setInitialState()
    }
  },
  created () {
    this.setInitialState()
  },
  methods: {
    ...mapActions(['domainLock', 'domainEpp', 'getDomain', 'reportSuccess', 'reportError']),
    setInitialState () {
      if (this.domainPopulated) {
        this.registrar_lock = Boolean(Number(this.domain.IsLocked))
      }
    },
    switchModalState (action) {
      this.modal = !this.modal
      if (action === 'cancel') {
        this.registrar_lock = !this.registrar_lock
      }
    },
    async setRegLock () {
      this.loading = true

      try {
        const data = {
          lock: Number(this.registrar_lock),
          domain_id: this.domainid
        }
        const response = await this.domainLock(data)

        if (response.result === 'success') {
          await this.getDomain({ refresh: true })
          this.reportSuccess(response.resultmsg || 'Registrar Lock updated.')
        } else {
          this.reportError(response.resultmsg)
        }

        this.loading = false
        this.modal = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    async sendEPP () {
      this.loading_epp = true

      try {
        const data = {
          domain_id: this.domainid
        }

        const response = await this.domainEpp(data)

        if (response.result === 'success') {
          this.reportSuccess('EPP code sent.')
        } else {
          this.reportError('Error sending EPP code')
        }
        this.loading_epp = false
      } catch (e) {
        this.loading_epp = false
        this.reportError(e)
      }
    }
  }
}
</script>
